import axiosInstance from '../services/axiosInstance';
import { envUrls } from './env';

// Uncomment this to test localhost
// envUrls.scansService = 'http://localhost:3005/';
// envUrls.trendsService = 'http://localhost:5002/trends/';
export default new (class TrendsService {
  // Compute new trends data for the query and filters passed in
  async computeTrends(payload) {
    return await axiosInstance
      .post(`${envUrls.trendsService}compute`, payload)
      .then((response) => {
        return response.data;
      });
  }
  async getTrendComputeStatus(payload) {
    return await axiosInstance
      .post(`${envUrls.trendsService}check-status`, payload)
      .then((response) => {
        return response.data;
      });
  }
  // Check the DB for existing trends for this particular scan and filter combination - If none found, it will call computeTrends
  async fetchTrends(payload) {
    return await axiosInstance
      .post(`${envUrls.trendsService}fetch`, payload)
      .then((response) => {
        return response.data;
      });
  }
  // Fetch data to populate the color and size dropdowns for the trends heatmap
  async fetchTrendsTreemapOptions() {
    return await axiosInstance
      .get(`${envUrls.trendsService}treemap-options`)
      .then((response) => {
        return response.data;
      });
  }
  // Delete all trends associated with a scan (if passing in scan_id only) -OR- If passing in source, filters, and query it will delete a specific set of Trends for a given scan (Trend data affiliated with that particular filter combination)
  async deleteTrends(payload) {
    return await axiosInstance
      .post(`${envUrls.trendsService}delete`, payload)
      .then((response) => {
        return response.data;
      });
  }
})();
